export enum PanelType {
    Position = 'Position',
    History = 'History',
}
